//#region INITIAL_STATE
import {isAdmin} from 'utils/insightUsers';

interface OktaUserInfo {
  email: string;
  name: string;
  given_name: string;
  family_name: string;
  groups: string[];
  zoneinfo: string;
  sub: string;
  updated_at: number;
  locale: string;
}

export interface UserInfoState {
  userInfo: OktaUserInfo | null;
  roles: string[];
  isAdmin: boolean;
  debugMode: boolean;
  errors: string[];
}

export const initialState: UserInfoState = {
  userInfo: null,
  roles: [],
  isAdmin: false,
  debugMode: false,
  errors: [],
};
//#endregion INITIAL_STATE

function getLocalSettings(settingType: string) {
  const localStorageValue = localStorage.getItem(settingType);

  if (localStorageValue === null) {
    return false;
  } else if (localStorageValue === 'true') {
    return true;
  } else {
    return false;
  }
}

//#region ACTIONS
export const actionTypes = {
  UPDATE_USER_INFO: 'UPDATE_USER_INFO',
  SET_ROLES: 'SET_ROLES',
  TOGGLE_DEBUG_MODE: 'TOGGLE_DEBUG_MODE',
  ADD_ERROR: 'ADD_ERROR',
} as const;

type ActionType = typeof actionTypes;

type Action =
  | {type: ActionType['UPDATE_USER_INFO']; payload: OktaUserInfo}
  | {type: ActionType['SET_ROLES']; payload: string[]}
  | {type: ActionType['TOGGLE_DEBUG_MODE']}
  | {type: ActionType['ADD_ERROR']; payload: string};
//#endregion ACTIONS

export const reducer = (state: UserInfoState, action: Action): UserInfoState => {
  switch (action.type) {
    case actionTypes.UPDATE_USER_INFO:
      const {email} = action.payload;
      const admin = isAdmin(email);
      const localSettingsDebugMode = getLocalSettings('debugMode');

      return {
        ...state,
        userInfo: action.payload,
        isAdmin: admin,
        debugMode: localSettingsDebugMode,
      };
    case actionTypes.TOGGLE_DEBUG_MODE:
      localStorage.setItem('debugMode', (!state.debugMode).toString());
      return {
        ...state,
        debugMode: !state.debugMode,
      };
    default:
      return state;
  }
};
